export default function unofficialTranscripts() {
    return {
        certificates: [],
        gradeOptions: [],
       
        peopleCodeId: '',
        message: '',
        transcriptGroups: [],
        profileList: '',
        peopleList: '',
        addressDetails: '',
        phoneDetails: '',
        people: '',

        formatDate(dateValue) {
            if (dateValue != undefined && dateValue != "" && dateValue != null && dateValue != "N/A" && dateValue != 0) {
                const date = new Date(dateValue);
                const month = date.getMonth() + 1; // Month is zero-based, so add 1
                const day = date.getDate();
                const year = date.getFullYear();
                return `${month}/${day}/${year}`;
            }
            else {
                return dateValue;
            }
        },
        formatEventId(eventId) {
            if (eventId != null) {
              return eventId.replace("_", " ");
            }
        },
        formatGPA(gpa) {
            return gpa.toFixed(2);
        },
        bindCertificates() {
            //"P001001574";
            fetch('/api/StudentAPI/GetAwardCertificates', { "method": "GET" })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    }
                }).then(response => {

                    if (response != undefined && response.isSuccess) {
                        this.certificates = response.certificates;

                    } else {
                        this.showErrorMesage = "An unknown error has occurred. Please try again later."
                    }

                });
        },

        bindUnofficalTranscripts() {
             //"P000773929";
            fetch('/api/StudentAPI/UnofficialTranscripts', { "method": "GET" })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    }
                }).then(response => {

                    if (response != undefined && response.isSuccess) {
                        this.transcriptGroups = response.transcriptGroups;

                    } else {
                        this.showErrorMesage = "An unknown error has occurred. Please try again later."
                    }

                });

        },
        bindProfile() {
            fetch('/api/UserAPI/GetProfile', { "method": "GET" })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    }
                }).then(response => {
                    if (response != undefined && response.isSuccess) {
                        this.peopleList = response.people;
                        //If 1 then show Local Address object
                        //If 2 then Business Address
                        //If 3 then Permanent Address
                        if (response.people.preferredAddressType == 1) {
                            this.addressDetails = response.localAddress;
                        } else if (response.people.preferredAddressType == 2) {
                            this.addressDetails = response.businessAddress;
                        } else {
                            this.addressDetails = response.permanentAddress;
                        } this.phoneDetails = response.phoneDetails;
                        this.people = response.people;


                    } else {
                        this.showErrorMesage = "An unknown error has occurred. Please try again later."
                    }

                });

        },

        init() {
            this.bindCertificates();
            this.bindUnofficalTranscripts();
            this.bindProfile();
        }
       

    }
}